// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import VueIziToast from 'vue-izitoast'
import VeeValidate from 'vee-validate'
import VueI18n from 'vue-i18n'
import VueMoment from 'vue-moment'

import VueQuillEditor from 'vue-quill-editor'
import { Quill } from 'vue-quill-editor'
import htmlEditButton from "quill-html-edit-button"
var Block = Quill.import('blots/block')
Block.tagName = 'DIV'
Quill.register(Block, true)
Quill.register('modules/htmlEditButton', htmlEditButton)

import VueFlatPickr from 'vue-flatpickr-component'
import * as VueGoogleMaps from 'vue2-google-maps'

import 'izitoast/dist/css/iziToast.min.css'
import 'flatpickr/dist/flatpickr.css'

import App from './App'
import router from './router'

import * as Auth from '@/shared/auth'
import * as Helper from '@/shared/helper'
import * as Api from '@/shared/api'

// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'


/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'
/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
/* import specific icons */
import { faThumbtack, faLock, faLockOpen } from '@fortawesome/free-solid-svg-icons'
/* add icons to the library */
library.add(faThumbtack, faLock, faLockOpen)
/* add font awesome icon component */
Vue.component('FontAwesomeIcon', FontAwesomeIcon)


const envi = process.env

const lang = {
  en:require('@/locales/en.json'),
  zh:require('@/locales/zh.json'),
  bn:require('@/locales/bn.json'),
  ms:require('@/locales/ms.json'),
  my:require('@/locales/my.json'),
  th:require('@/locales/th.json'),
  tl:require('@/locales/tl.json'),
  vi:require('@/locales/vi.json'),
  ar:require('@/locales/ar.json'),
  es:require('@/locales/es.json'),
  ja:require('@/locales/ja.json'),
  hi:require('@/locales/hi.json'),
  fr:require('@/locales/fr.json'),
  pt:require('@/locales/pt.json'),
  fa:require('@/locales/fa.json')
}

VeeValidate.Validator.localize('en', lang)
// todo
// cssVars()
Vue.use(BootstrapVue)
Vue.use(VueIziToast)
Vue.use(VeeValidate)
Vue.use(VueI18n)
Vue.use(VueMoment)
Vue.use(VueQuillEditor, {
  modules:{
    toolbar:[
      ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
      ['blockquote', 'code-block'],

      [{ 'header': 1 }, { 'header': 2 }],               // custom button values
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
      [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
      [{ 'direction': 'rtl' }],                         // text direction

      [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

      [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
      [{ 'font': [] }],
      [{ 'align': [] }],

      ['clean']
    ]
}})
Vue.use(VueFlatPickr)
Vue.use(VueGoogleMaps, {
  load:{
    key:envi.VUE_APP_GMAP_APIKEY,
    libraries:'places' // necessary for places input
  }
})

const plugin = {
  install(){
    Vue.auth = Auth
    Vue.prototype.$auth = Auth
    Vue.helper = Helper
    Vue.prototype.$helper = Helper
    Vue.api = Api
    Vue.prototype.$api = Api
  }
}
Vue.use(plugin)

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale:'en', // set locale
  messages:lang, // set locale messages
})

/* eslint-disable no-new */
new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
